import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsAdjustmentProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import { ADJUSTMENT_STATUS } from "@letsbit/malcolmlb";
import { formatLastFour } from "utils/paymentCardUtils";
import { useTranslationConstants } from "hooks/utils/useTranslationConstants";

export const HistoryDetailsAdjustment: React.FC<
  HistoryDetailsAdjustmentProps
> = ({ data: adjustment }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();
  const { getAdjustmentsOperations } = useTranslationConstants();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case ADJUSTMENT_STATUS.AUTHORIZED:
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case ADJUSTMENT_STATUS.REJECTED:
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6">
      <DetailsField
        label={`${formatMessage(messages.type)}:`}
        value={
          getAdjustmentsOperations(adjustment.extra_data.type_adjustment) ?? ""
        }
      />
      <DetailsField
        label={formatMessage(messages.adjustmentAmount)}
        value={
          formatValue(adjustment.amount, adjustment.precision) +
          " " +
          adjustment.ticker_id.toUpperCase()
        }
      />
      <DetailsField
        label={formatMessage(messages.details)}
        value={formatLastFour(adjustment.extra_data.description || "")}
      />
      <DetailsField
        label={formatMessage(messages.status)}
        value={getStatus(adjustment.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={adjustment.tid ?? ""}
        copy
      />
    </div>
  );
};
